/**
 * vendorDisplay.js — Shared display logic for vendor profiles.
 *
 * Single source of truth for category-aware rendering rules.
 * Used by: VendorDetail.jsx, BrowseVendors.jsx, and any future vendor card.
 */

// Categories where the provider is a fixed location (customers come to them)
const FIXED_LOCATION_CATEGORIES = ['venue', 'event venue', 'event space', 'event hall', 'banquet hall'];

/**
 * Determine if a vendor is a fixed-location provider (e.g., Venue).
 * @param {Object} vendor - Vendor object with `categories` array
 * @returns {boolean}
 */
export function isFixedLocationProvider(vendor) {
  const cats = vendor?.categories || [];
  return cats.some(c =>
    FIXED_LOCATION_CATEGORIES.includes(c.toLowerCase())
  );
}

/**
 * Get the service area display string for a vendor.
 * Venue-type providers show location-based text instead of radius.
 * @param {Object} vendor - Vendor object with `categories`, `service_radius`, `city`, `state`
 * @returns {string}
 */
export function getServiceAreaDisplay(vendor) {
  if (isFixedLocationProvider(vendor)) {
    const city = vendor?.city;
    const state = vendor?.state;
    if (city && state) return `Located in ${city}, ${state}`;
    if (city) return `Located in ${city}`;
    return 'Fixed venue location';
  }

  const radius = vendor?.service_radius;
  if (!radius || radius <= 0) return 'Service area varies';
  return `Serves within ${radius} miles`;
}
